<app-page-header>
    {{ 'Quick Start' }}
    <p>{{ 'Get started with PayHOA by completing the following tasks:' }}</p>
</app-page-header>

<div class="grid-layout grid-2-right-panel">
    <section class="grid-item">
        <ng-container *ngFor="let card of cards | keyvalue: originalOrder; let i = index">
            <mat-card animated delayed [fadeFrom]="'bottom'">
                <mat-card-content>
                    <a mat-flat-button color="accent" disableRipple
                       [disabled]="isLoadingInitialCardData || card.value.isDisabled"
                       [routerLink]="card.value.actionUrl">
                        <app-avatar-block [isLoadingInitialData]="isLoadingInitialCardData"
                                          [svgIcon]="card.value?.svg"
                                          [icon]="card.value?.icon"
                                          [wrappedText]="true">
                            <span avatarTitle>{{ card.value.title }}</span>
                            <span avatarDescription>{{ card.value.description }}</span>
                        </app-avatar-block>
                    </a>
                </mat-card-content>
            </mat-card>
        </ng-container>
    </section>
    <mat-card class="grid-item">
        <mat-card-content>
            <mat-card class="video-card" nestedCard animated [fadeFrom]="'bottom'">
                <mat-card-title>{{ 'Watch 15 Minute Overview' }}</mat-card-title>
                <mat-card-content>
                    <iframe [src]="videoSrc"
                            style="position:absolute;top:0;left:0;width:100%;height:100%;"
                            allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                    <script [src]="'https://player.vimeo.com/api/player.js'"></script>
                </mat-card-content>
            </mat-card>

            <mat-card class="contact-card" nestedCard animated [fadeFrom]="'bottom'">
                <mat-card-title>{{ 'Contact Us' }}</mat-card-title>
                <mat-card-content>
                    <app-avatar-block [isLoadingInitialData]="isLoadingInitialRepData | async"
                                      [iconImage]="assignedSalesRep.profileImage"
                                      [initials]="assignedSalesRep.initials">
                        <span avatarTitle>{{ assignedSalesRep.name }}</span>
                        <span avatarDescription>{{ assignedSalesRep.description }}</span>
                        <a mat-flat-button disableRipple
                           color="accent"
                           target="_blank"
                           href="mailto:{{ assignedSalesRep.email }}">
                            <mat-icon [svgIcon]="'v2:fi-br-envelope'"></mat-icon>
                            {{ assignedSalesRep.email }}
                        </a>
                        <a *ngIf="assignedSalesRep.phone"
                           mat-flat-button disableRipple
                           color="accent"
                           href="tel:{{ assignedSalesRep.phone }}">
                            <mat-icon [svgIcon]="'v2:fi-br-phone'"></mat-icon>
                            +{{ assignedSalesRep.phone | legfiPhone }}
                        </a>
                    </app-avatar-block>
                </mat-card-content>
            </mat-card>
        </mat-card-content>
        <mat-card-actions>
            <button mat-flat-button color="accent" disableRipple (click)="onDemoSchedulerClick()">{{ 'Book a Meeting' }}</button>
            <a mat-flat-button color="accent" disableRipple target="_blank" [href]="howToUrl">{{ 'Go to Help Center' }}</a>
        </mat-card-actions>
    </mat-card>
</div>
